/**
 * Detect fn
 */
export default () => 'find' in Array.prototype
